import React from 'react';
import '../styles/aspireSection.css';

const AspireSection = ({
  showLogos = true,
  layout = 'split',
  quoteHighlight = true,
  showCTA = true,
  ctaText = "Request a Consultation",
  ctaLink = "https://allseasons.propertyserviceportal.com/",
  variant = 'full',
  customCTA = null,
}) => {
  const isCompact = variant === 'compact';
  
  return (
    <section className={`aspire-section ${layout} ${variant}`}>
      <div className="aspire-overlay"></div>
      <div className="aspire-container">
        <div className="aspire-content">
          <div className="aspire-header">
            {!isCompact && (
              <div className="aspire-badge">
                <span className="tech-icon">⚡</span>
                <span>Professional Technology</span>
              </div>
            )}
            <h2 className="aspire-title">
              {isCompact ? 'Powered by Aspire Software' : 'All Seasons Runs on Professional Software'}
            </h2>
            <p className="aspire-subtitle">
              {isCompact 
                ? 'Professional project management technology for transparency and accuracy.'
                : 'We use Aspire to deliver transparency, accuracy, and seamless communication throughout your project.'
              }
            </p>
          </div>

          <div className="aspire-benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">[01]</div>
              <h3>Real-Time Updates</h3>
              <p>{isCompact ? "Track progress" : "Track your project's progress with updates, scheduling alerts, and milestone notifications."}</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">[02]</div>
              <h3>Accurate Quotes</h3>
              <p>{isCompact ? 'Transparent pricing' : 'Receive estimates with transparent pricing and breakdowns—no surprises.'}</p>
            </div>
            
            {!isCompact && (
              <>
                <div className="benefit-card">
                  <div className="benefit-icon">[03]</div>
                  <h3>Seamless Communication</h3>
                  <p>Stay connected with updates and direct messaging throughout your project.</p>
                </div>
                
                <div className="benefit-card">
                  <div className="benefit-icon">[04]</div>
                  <h3>Complete Documentation</h3>
                  <p>Access all project details, invoices, and maintenance schedules in one organized system.</p>
                </div>
              </>
            )}
          </div>

          {!isCompact && quoteHighlight && (
            <>
              <div className="aspire-quote-card">
                <div className="quote-content">
                  <div className="quote-mark">"</div>
                  <p className="quote-text">
                    We chose Aspire because our customers deserve the best. This professional software
                    ensures every detail is tracked, every timeline is met, and every communication is clear.
                    It's how we deliver the exceptional service our clients expect.
                  </p>
                  <div className="quote-author">
                    <div className="author-info">
                      <span className="author-name">Matt Taylor</span>
                      <span className="author-title">Partner, All Seasons Landscaping</span>
                    </div>
                  </div>
                </div>
              </div>
              {showCTA && (
                <div className="quote-cta-wrapper">
                  {customCTA ? (
                    <div className="custom-cta-wrapper">
                      {customCTA}
                    </div>
                  ) : (
                    <a href={ctaLink} className="aspire-quote-cta-button">
                      <span>{ctaText}</span>
                      <span className="cta-arrow">→</span>
                    </a>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default AspireSection;
